import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import RequireModule from '@/core/modules/RequireModule';
import RequirePermission from '@/auth/RequirePermission';
import { Modules } from '@/core/modules/moduleKeys';
import { Perm } from '@/auth/permissions';

// Pages load when first opened (NFR-04).
const CapturePage = lazy(() => import('./pages/CapturePage'));
const CompliancePage = lazy(() => import('./pages/CompliancePage'));
const OutlookAddinPage = lazy(() => import('./pages/OutlookAddinPage'));

/** Document Management (docs §246 on): the capture desk needs the module on and a capture or administration right. */
export const documentsRoutes: RouteObject[] = [
  {
    path: 'documents/capture',
    element: (
      <RequireModule module={Modules.Documents}>
        <RequirePermission anyOf={[Perm.Documents.Capture, Perm.Documents.Admin, Perm.Evidence.Manage]}>
          <CapturePage />
        </RequirePermission>
      </RequireModule>
    ),
  },
  // The compliance register (docs §256): compliance officers, document administrators.
  {
    path: 'documents/compliance',
    element: (
      <RequireModule module={Modules.Documents}>
        <RequirePermission anyOf={[Perm.Documents.Compliance, Perm.Documents.Admin, Perm.Evidence.Manage]}>
          <CompliancePage />
        </RequirePermission>
      </RequireModule>
    ),
  },
];

/** The Outlook add-in's task pane (docs §259): signed in, in its own narrow frame, for those who may file documents. */
export const documentsOfficeRoutes: RouteObject[] = [
  {
    path: '/office/outlook',
    element: (
      <RequireModule module={Modules.Documents}>
        <RequirePermission permission={Perm.Evidence.Upload}>
          <OutlookAddinPage />
        </RequirePermission>
      </RequireModule>
    ),
  },
];
